import React from 'react';
export function Footer() {
  return <footer className="w-full border-t-2 border-ink bg-cream" data-id="element-47" data-mp="32wd2qgad7ltj">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-2 px-5 py-8 text-center text-sm text-graphite/80 sm:px-8" data-id="element-48" data-mp="3gfitoga0y7d2">
        <p className="font-display text-base font-bold text-ink" data-id="element-49" data-mp="32pfg0dp7nlz8">
          Manos a la Casa
        </p>
        <p data-id="element-50" data-mp="36ppkflxcu4bz">
          © 2025 Manos a la Casa · Todos los derechos reservados · Libro Digital
        </p>
      </div>
    </footer>;
}